import React from "react";
import Loadable from "react-loadable";
import Addresslist from "./Views/Order/Payment/addresslist";

function Loading() {
  return <div className="loading"></div>;
}

// Home
const Home = Loadable({
  loader: () => import("./Views/Home/Home"),
  loading: Loading,
});
// About Us
const Aboutus = Loadable({
  loader: () => import("./Views/AboutUs/AboutUs"),
  loading: Loading,
});

const Contact = Loadable({
  loader: () => import("./Views/ContactUs/Contactus"),
  loading: Loading,
});

//Privacy
const Privacy = Loadable({
  loader: () => import("./Views/Privacy/Privacy"),
  loading: Loading,
});
//return policy
const ReturnPolicy = Loadable({
  loader: () => import("./Views/Return-Policy/Return-Policy"),
  loading: Loading,
});
//Usage
const Usage = Loadable({
  loader: () => import("./Views/Usage/usage"),
  loading: Loading,
});
// Favourite
const Favourite = Loadable({
  loader: () => import("./Views/Favourite/favourite"),
  loading: Loading,
});
// Product
const Product = Loadable({
  loader: () => import("./Views/Product/product"),
  loading: Loading,
});
const viewAllProducts = Loadable({
  loader: () => import("./Views/Product/ViewAllProducts/viewAllProducts"),
  loading: Loading,
});
const ProductDetails = Loadable({
  loader: () => import("./Views/Product/ProductDetails/ProductDetails"),
  loading: Loading,
});
// Cart
const Cart = Loadable({
  loader: () => import("./Views/Order/CheckOut/checkout-v1"),
  loading: Loading,
});
// Payment
const PaymentView = Loadable({
  loader: () => import("./Views/Order/Payment/PaymentView-v1"),
  loading: Loading,
});
// addresslist
// const AddressList = Loadable({
//     loader: () => import('./Views/Order/Payment/addresslist'),
//     loading: Loading,
// });
// Notifications
const Notifications = Loadable({
  loader: () => import("./Views/Notifications/Notifications"),
  loading: Loading,
});
const Chat = Loadable({
  loader: () => import("./Views/Chat/Chat"),
  loading: Loading,
});
// Profile
const Profile = Loadable({
  loader: () => import("./Views/Profile/ProfileHome"),
  loading: Loading,
});
const EditProfile = Loadable({
  loader: () => import("./Views/Profile/EditProfile/EditProfile"),
  loading: Loading,
});

const MyOrders = Loadable({
  loader: () => import("./Views/Profile/MyOrders/MyOrders"),
  loading: Loading,
});

const OrderDetails = Loadable({
  loader: () => import("./Views/Profile/MyOrders/OrderDetails/OrderDetails"),
  loading: Loading,
});

const Category = Loadable({
  loader: () => import("./Views/Category/Category"),
  loading: Loading,
});

const ViewAddress = Loadable({
  loader: () => import("./Views/Profile/Adress/ViewAdress/ViewAdress"),
  loading: Loading,
});

const AddAddress = Loadable({
  loader: () => import("./Views/Profile/Adress/AddAddress/AddAddress"),
  loading: Loading,
});
const EditAddress = Loadable({
  loader: () => import("./Views/Profile/Adress/EditAddress/EditAddress"),
  loading: Loading,
});
const routes = [
  // Home
  { path: `/Catch-It`, exact: true, name: "Home", component: Home },
  // About us
  {
    path: `/Catch-It/about-us`,
    exact: true,
    name: "About us",
    component: Aboutus,
  },
  // contact-us
  // { path: `/Catch-It/contact-us`, exact: true, name: 'contact-us', component: ContactUS },
  {
    path: `/Catch-It/contact-us`,
    exact: true,
    name: "Contact",
    component: Contact,
  },
  //Privacy
  {
    path: `/Catch-It/Privacy`,
    exact: true,
    name: "Terms And Conditions",
    component: Privacy,
  },
  {
    path: `/Catch-It/return-policy`,
    exact: true,
    name: "return policy",
    component: ReturnPolicy,
  },
  //Usage
  { path: `/Catch-It/usage`, exact: true, name: "usage", component: Usage },

  //Favourite
  {
    path: `/Catch-It/Favourite`,
    exact: true,
    name: "Favourite",
    component: Favourite,
  },
  //Product
  {
    path: `/Catch-It/Product/:id`,
    exact: true,
    name: "Product",
    component: ProductDetails,
  },
  //view All Products
  {
    path: `/Catch-It/All-Product/:id`,
    exact: true,
    name: "view All Product",
    component: viewAllProducts,
  },
  //  Payment
  {
    path: `/Catch-It/PaymentView`,
    exact: true,
    name: "PaymentView",
    component: PaymentView,
  },
  //  addresslist
  {
    path: `/Catch-It/Addresslist`,
    exact: true,
    name: "Addresslist",
    component: Addresslist,
  },
  //  Cart
  {
    path: `/Catch-It/ShoppingCart`,
    exact: true,
    name: "ShoppingCart",
    component: Cart,
  },
  //  Notifications
  {
    path: `/Catch-It/Notifications`,
    exact: true,
    name: "Notifications",
    component: Notifications,
  },
  {
    path: `/Catch-It/chat`,
    exact: true,
    name: "Chat",
    component: Chat,
  },
  //  Profile
  {
    path: `/Catch-It/Profile`,
    exact: true,
    name: "Profile",
    component: Profile,
  },
  {
    path: `/Catch-It/EditProfile`,
    exact: true,
    name: "EditProfile",
    component: EditProfile,
  },
  {
    path: `/Catch-It/MyOrders`,
    exact: true,
    name: "MyOrders",
    component: MyOrders,
  },
  {
    path: `/Catch-It/OrderDetails`,
    exact: true,
    name: "OrderDetails",
    component: OrderDetails,
  },

  {
    path: `/Catch-It/Categories/:id`,
    exact: true,
    name: "Category",
    component: Category,
  },
  {
    path: `/Catch-It/ViewAddress`,
    exact: true,
    name: "View Address",
    component: ViewAddress,
  },
  {
    path: `/Catch-It/AddAddress`,
    exact: true,
    name: "Add Address",
    component: AddAddress,
  },
  {
    path: `/Catch-It/EditAddress`,
    exact: true,
    name: "Edit Address",
    component: EditAddress,
  },
];

export default routes;
